"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("page", {
    attrs: {
      "return-menu": "/farm-management/dashboard",
      menu: _vm.page.children,
      subtitle: _vm.page.meta.title
    },
    scopedSlots: _vm._u([{
      key: "context",
      fn: function fn() {
        return [_c("section", {
          staticClass: "production-dashboard"
        }, [_c("header", {
          staticClass: "page-header"
        }, [_c("div", {
          staticClass: "page-header-left"
        }, [_c("h1", {
          staticClass: "page-title"
        }, [_vm._v("\n            Dashboard\n          ")]), _vm._v(" "), _c("span", {
          staticClass: "page-subtitle"
        }, [_vm._v("Produção de mudas")])]), _vm._v(" "), _c("div", {
          staticClass: "page-header-right"
        }, [_c("span", {
          staticClass: "page-date-label"
        }, [_vm._v("Data de referência")]), _vm._v(" "), _c("span", {
          staticClass: "page-date-value"
        }, [_vm._v(_vm._s(_vm.formatReferenceDate(_vm.referenceDate)))])])]), _vm._v(" "), _c("b-columns", {
          staticClass: "columns"
        }, [_c("b-column", {
          staticClass: "left-column",
          attrs: {
            size: "4"
          }
        }, [_c("b-card", {
          staticClass: "card-block"
        }, [_c("h2", {
          staticClass: "card-title"
        }, [_vm._v("\n              Distribuição da produção de mudas\n            ")]), _vm._v(" "), _c("div", {
          staticClass: "card-body donut-wrapper"
        }, [_c("canvas", {
          ref: "statusDistributionChart"
        }), _vm._v(" "), _c("div", {
          staticClass: "donut-center"
        }, [_c("div", {
          staticClass: "donut-center-value"
        }, [_vm._v("\n                  " + _vm._s((_vm.summary.totalCurrent / 1000).toFixed(1).replace(".", ",")) + " Mil\n                ")]), _vm._v(" "), _c("div", {
          staticClass: "donut-center-label"
        }, [_vm._v("\n                  Total mudas\n                ")])])]), _vm._v(" "), _c("ul", {
          staticClass: "legend-list"
        }, _vm._l(_vm.productionDistribution.status, function (item) {
          return _c("li", {
            key: item.label
          }, [_c("span", {
            staticClass: "legend-color",
            style: {
              backgroundColor: item.color
            }
          }), _vm._v(" "), _c("span", {
            staticClass: "legend-label"
          }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c("span", {
            staticClass: "legend-value"
          }, [_vm._v("\n                  " + _vm._s((item.value / 1000).toFixed(0)) + " Mil (" + _vm._s(item.percent.toFixed(2).replace(".", ",")) + "%)\n                ")])]);
        }), 0)]), _vm._v(" "), _c("b-card", {
          staticClass: "card-block"
        }, [_c("h2", {
          staticClass: "card-title"
        }, [_vm._v("\n              Relação das mudas\n            ")]), _vm._v(" "), _c("b-table", {
          attrs: {
            data: _vm.varieties,
            bordered: false,
            striped: true,
            narrowed: true
          }
        }, [_c("b-table-column", {
          attrs: {
            field: "name",
            label: "Variedade"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function fn(props) {
              return [_vm._v("\n                " + _vm._s(props.row.name) + "\n              ")];
            }
          }])
        }), _vm._v(" "), _c("b-table-column", {
          attrs: {
            field: "quantity",
            label: "Quantidade",
            numeric: ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function fn(props) {
              return [_vm._v("\n                " + _vm._s(props.row.quantity.toLocaleString("pt-BR")) + "\n              ")];
            }
          }])
        })], 1), _vm._v(" "), _c("div", {
          staticClass: "table-footer"
        }, [_c("span", [_vm._v("Total")]), _vm._v(" "), _c("span", [_vm._v(_vm._s(_vm.totalVarieties.toLocaleString("pt-BR")))])])], 1)], 1), _vm._v(" "), _c("b-column", {
          staticClass: "right-column"
        }, [_c("section", {
          staticClass: "top-metrics card-block"
        }, [_c("div", {
          staticClass: "metric"
        }, [_c("div", {
          staticClass: "metric-value"
        }, [_vm._v("\n                " + _vm._s((_vm.summary.totalCurrent / 1000).toFixed(1).replace(".", ",")) + " Mil\n              ")]), _vm._v(" "), _c("div", {
          staticClass: "metric-label"
        }, [_vm._v("\n                Total atual\n              ")])]), _vm._v(" "), _c("div", {
          staticClass: "metric"
        }, [_c("div", {
          staticClass: "metric-value"
        }, [_vm._v("\n                " + _vm._s((_vm.summary.totalPrevious / 1000).toFixed(1).replace(".", ",")) + " Mil\n              ")]), _vm._v(" "), _c("div", {
          staticClass: "metric-label"
        }, [_vm._v("\n                Total anterior\n              ")])]), _vm._v(" "), _c("div", {
          staticClass: "metric"
        }, [_c("div", {
          staticClass: "metric-value"
        }, [_vm._v("\n                " + _vm._s((_vm.summary.plantingBetweenCounts / 1000).toFixed(1).replace(".", ",")) + " Mil\n              ")]), _vm._v(" "), _c("div", {
          staticClass: "metric-label"
        }, [_vm._v("\n                Total em Plantio\n              ")])]), _vm._v(" "), _c("div", {
          staticClass: "metric"
        }, [_c("div", {
          staticClass: "metric-value"
        }, [_vm._v("\n                " + _vm._s(_vm.summary.shippedBetweenCounts) + "\n              ")]), _vm._v(" "), _c("div", {
          staticClass: "metric-label"
        }, [_vm._v("\n                Total em Expedição\n              ")])])]), _vm._v(" "), _c("b-card", {
          staticClass: "card-block"
        }, [_c("header", {
          staticClass: "card-header"
        }, [_c("h2", {
          staticClass: "card-title"
        }, [_vm._v("\n                Tempo de viveiro\n              ")]), _vm._v(" "), _c("span", {
          staticClass: "card-subtitle"
        }, [_vm._v("Distribuição das mudas por estágio")])]), _vm._v(" "), _c("div", {
          staticClass: "card-body"
        }, [_c("canvas", {
          ref: "nurseryTimeChart"
        })]), _vm._v(" "), _c("ul", {
          staticClass: "legend-list horizontal"
        }, _vm._l(_vm.statusLegend, function (item) {
          return _c("li", {
            key: item.label
          }, [_c("span", {
            staticClass: "legend-color",
            style: {
              backgroundColor: item.color
            }
          }), _vm._v(" "), _c("span", {
            staticClass: "legend-label"
          }, [_vm._v(_vm._s(item.label))])]);
        }), 0)]), _vm._v(" "), _c("b-card", {
          staticClass: "card-block"
        }, [_c("header", {
          staticClass: "card-header"
        }, [_c("h2", {
          staticClass: "card-title"
        }, [_vm._v("\n                Previsão\n              ")]), _vm._v(" "), _c("span", {
          staticClass: "card-subtitle"
        }, [_vm._v("Distribuição da previsão de expedição")])]), _vm._v(" "), _c("div", {
          staticClass: "card-body"
        }, [_c("canvas", {
          ref: "forecastChart"
        })]), _vm._v(" "), _c("ul", {
          staticClass: "legend-list horizontal"
        }, _vm._l(_vm.statusLegendWithoutBlank, function (item) {
          return _c("li", {
            key: item.label
          }, [_c("span", {
            staticClass: "legend-color",
            style: {
              backgroundColor: item.color
            }
          }), _vm._v(" "), _c("span", {
            staticClass: "legend-label"
          }, [_vm._v(_vm._s(item.label))])]);
        }), 0)]), _vm._v(" "), _c("b-card", {
          staticClass: "card-block"
        }, [_c("h2", {
          staticClass: "card-title"
        }, [_vm._v("\n              Distribuição das mudas por local\n            ")]), _vm._v(" "), _c("div", {
          staticClass: "card-body"
        }, [_c("canvas", {
          ref: "locationDistributionChart"
        })])])], 1)], 1)], 1)];
      },
      proxy: true
    }])
  });
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;